import React from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';

export const IconButtonWithTooltip: React.FC<IconButtonProps> = ({ title, ...props }) => (
  <Tooltip title={title}>
    <IconButton aria-label={title} {...props} />
  </Tooltip>
);
